import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Hero from './components/Hero';
import Greenhouse from './components/Greenhouse';
import Events from './components/Events';
import OurStory from './components/OurStory';
import Contact from './components/Contact';
import Greeter from './components/Greeter';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <Hero />
      <Greenhouse />
      <Events />
      <OurStory />
      <Contact />
      <Greeter />
      <Footer />
    </>
  );
}

export default App;
